export const shieldedPoolV2Abi = [
  { type: "error", name: "InvalidRoot", inputs: [] },
  { type: "error", name: "InputAlreadySpent", inputs: [] },
  { type: "error", name: "DuplicateCommitment", inputs: [] },
  { type: "error", name: "InvalidPublicAmount", inputs: [] },
  { type: "error", name: "InvalidFeeBase", inputs: [] },
  { type: "error", name: "InvalidExtDataHash", inputs: [] },
  { type: "error", name: "InvalidProof", inputs: [] },
  { type: "error", name: "InvalidFeeAttestation", inputs: [] },
  { type: "error", name: "UnexpectedFeeAttestation", inputs: [] },
  { type: "error", name: "DuplicateNullifier", inputs: [] },
  { type: "error", name: "DuplicateOutput", inputs: [] },
  { type: "error", name: "PublicInputNotInField", inputs: [] },
  {
    type: "function", name: "transact", stateMutability: "nonpayable",
    inputs: [
      { name: "args", type: "tuple", components: [
        { name: "proof", type: "bytes" }, { name: "root", type: "uint256" },
        { name: "inputNullifiers", type: "uint256[2]" }, { name: "outputCommitments", type: "uint256[3]" },
        { name: "publicAmount", type: "uint256" }, { name: "publicFeeBase", type: "uint256" },
        { name: "extDataHash", type: "bytes32" },
      ] },
      { name: "ext", type: "tuple", components: [
        { name: "recipient", type: "address" }, { name: "extAmount", type: "int256" },
        { name: "relayer", type: "address" }, { name: "relayerFee", type: "uint256" },
        { name: "encryptedOutput1", type: "bytes" }, { name: "encryptedOutput2", type: "bytes" },
        { name: "encryptedOutput3", type: "bytes" }, { name: "feeAttestation", type: "bytes" },
      ] },
    ], outputs: [],
  },
  { type: "function", name: "token", stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", name: "feeController", stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", name: "verifier", stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", name: "treasuryPubkey", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "quoteProtocolFee", stateMutability: "view", inputs: [{ type: "uint256" }], outputs: [{ type: "uint256" }] },
] as const;

export const verifierWrapperV2Abi = [
  {
    type: "function", name: "verifyProof", stateMutability: "view",
    inputs: [{ type: "bytes", name: "proof" }, { type: "uint256[12]", name: "publicInputs" }],
    outputs: [{ type: "bool" }],
  },
] as const;

export const feeControllerV2Abi = [
  { type: "function", name: "feeEnabled", stateMutability: "view", inputs: [], outputs: [{ type: "bool" }] },
] as const;

export const usd0V2Abi = [
  { type: "function", name: "mint", stateMutability: "nonpayable", inputs: [{ type: "uint256", name: "usdsAmount" }, { type: "uint256", name: "minUsd0Out" }, { type: "address", name: "receiver" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "redeem", stateMutability: "nonpayable", inputs: [{ type: "uint256", name: "usd0Amount" }, { type: "uint256", name: "minUsdsOut" }, { type: "address", name: "receiver" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "convertToShares", stateMutability: "view", inputs: [{ type: "uint256" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "convertToAssets", stateMutability: "view", inputs: [{ type: "uint256" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalAssets", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "managedAssets", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "protocolAccrued", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalSupply", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ type: "address" }], outputs: [{ type: "uint256" }] },
] as const;

export const usd0GatewayAbi = [
  { type: "function", name: "mintWithUSDC", stateMutability: "nonpayable", inputs: [{ type: "uint256", name: "usdcIn" }, { type: "uint256", name: "minUsd0Out" }, { type: "address", name: "receiver" }, { type: "uint256", name: "deadline" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "redeemToUSDC", stateMutability: "nonpayable", inputs: [{ type: "uint256", name: "usd0In" }, { type: "uint256", name: "minUsdcOut" }, { type: "address", name: "receiver" }, { type: "uint256", name: "deadline" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "previewUsdcOut", stateMutability: "view", inputs: [{ type: "uint256" }], outputs: [{ type: "uint256" }] },
] as const;
